import { stringToDate } from '@ui-seeker/utils'

export const removeDuplicatedDates = datesArray => {
  return [...new Set(datesArray)].map(d => stringToDate(d, 'yyyy-MM-dd'))
}